// Mirror of the backend types in cobstream-backend/src/services/logs/logs.types.ts.
// Kept narrow on purpose — only the surface the admin Logs tab touches.

export type LogSource = 'sentry' | 'posthog';
export type LogLevel = 'error' | 'warning' | 'info';
export type LogSort = 'lastSeen' | 'count' | 'firstSeen';
export type VendorStatus = 'ok' | 'error' | 'unconfigured';
export type SinceWindow = '1h' | '24h' | '7d' | '30d';

export const SINCE_WINDOWS: readonly SinceWindow[] = ['1h', '24h', '7d', '30d'];
export const LOG_LEVELS: readonly LogLevel[] = ['error', 'warning', 'info'];

// Mirrors `ProviderTag` from the backend streaming types so filter pills stay
// in lockstep with the canonical provider chain.
export const LOG_PROVIDERS: readonly string[] = [
  'vidlink',
  'vidzee',
  'moviesapi',
  'purstream',
  'klikxxi',
  'hollymoviehd',
];

// Mirrors `ProviderErrorKind` from the backend streaming types.
export const LOG_KINDS: readonly string[] = [
  'decrypt_failed',
  'parse_failed',
  'upstream_4xx',
  'upstream_5xx',
  'timeout',
  'not_supported',
  'unknown',
];

export interface LogRow {
  id: string;
  source: LogSource;
  title: string;
  level: LogLevel;
  count: number;
  firstSeen: string;
  lastSeen: string;
  provider: string | null;
  kind: string | null;
  permalink: string;
}

export interface LogQuery {
  source: 'sentry' | 'posthog' | 'both';
  since: SinceWindow;
  provider: string[];
  kind: string[];
  level: LogLevel[];
  q: string;
  sort: LogSort;
  bust?: boolean;
}

export interface LogsResponse {
  rows: LogRow[];
  vendorStatus: { sentry: VendorStatus; posthog: VendorStatus };
  cachedAt: string;
  fromCache: boolean;
}

export interface LogDetail {
  source: LogSource;
  raw: unknown;
  permalink: string;
}
